import * as Sentry from '@sentry/react';
import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import { revokeUserPat } from '@/services/user/revoke-user-pat';

export const useRevokeUserPat = (
  options?: Omit<
    UseMutationOptions<void, Error, string, unknown>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: revokeUserPat,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: ['user-pats'] });
      options?.onSuccess?.(data, variables, context, mutation);
    },
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'revoke-user-pat' },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
